import './PromptCardPlaceholder.scss';

export default function PromptCardPlaceholder() {
  return (
    <div className='matching-activity-prompt-area-question-mark-container'>
      <div className='matching-activity-prompt-area-question-mark'>?</div>
    </div>
  );
}
